import React from 'react'
import { Area, AreaChart as RechartsAreaChart } from 'recharts'

import {
  axisIdFor,
  BASE_COLOR,
  TimeseriesChartFrame,
} from '../timeseries-chart'
import { LemonadeAreaChartProps } from './area-chart.types'

// A stacked area reads best as fairly solid bands; overlaid (non-stacked) areas stay translucent
// so an area behind another is still visible.
const STACKED_FILL_OPACITY = 0.85
const OVERLAID_FILL_OPACITY = 0.2

/**
 * A timeseries area chart — one band per series. `stacked` cumulates them into a
 * part-to-whole breakdown over time; otherwise they overlay translucently.
 * Everything but the bands (axes, grid, tooltip, legend) comes from
 * `TimeseriesChartFrame`, shared with the line chart.
 */
export const LemonadeAreaChart = ({
  series,
  stacked = false,
  ...frameProps
}: LemonadeAreaChartProps) => (
  <TimeseriesChartFrame
    chart={RechartsAreaChart}
    series={series}
    {...frameProps}
  >
    {series.map((s) => (
      <Area
        key={s.name}
        yAxisId={axisIdFor(s.axis)}
        type="monotone"
        dataKey={s.name}
        name={s.label ?? s.name}
        stackId={stacked ? 'stack' : undefined}
        stroke={s.color ?? BASE_COLOR}
        strokeWidth={2}
        fill={s.color ?? BASE_COLOR}
        fillOpacity={stacked ? STACKED_FILL_OPACITY : OVERLAID_FILL_OPACITY}
        dot={false}
        activeDot={{ r: 4 }}
        connectNulls
        isAnimationActive
        animationDuration={800}
        animationEasing="ease-out"
      />
    ))}
  </TimeseriesChartFrame>
)
